import { PapiComment } from '@wix/da-papi-types';
import { CommentableTypes } from '../../Comment/redux/types';

/**
 * The source of the editor.
 *
 * Are we:
 * - Replying to another component?
 * - Adding an standalone comment directly to an item?
 * - etc...
 */
export enum CommentEditorSource {
  /** The user intends to post a comment at the root level of an item. */
  Independent = 'independent',

  /** The user intends to reply to a comment that already exists. */
  Reply = 'reply',

  /** The user is editing an existing comment. */
  Edit = 'edit',
}

export enum RequestError {
  GeneralError = 0,
}

export type CommentPublisher = {
  editorId: string;
  typeId: CommentableTypes;
  itemId: string | number;
  rawContentState: string;
  editComment?: PapiComment;
  replyComment?: PapiComment;
  messageId?: string;
  folderId?: number | null;
  shouldDeleteMessage?: boolean;
};

export type CommentPublisherResult = {
  editorId: string;
  comment?: PapiComment;
  isEdit: boolean;
  isReply: boolean;
  error?: RequestError;
  errorMsg?: string;

  /**
   * Should the comment editor be cleared after this result?
   */
  shouldResetEditor?: boolean;

  /**
   * Used for comment persistence in the notification center.
   *
   * @deprecated
   */
  messageId?: string;

  /**
   * Used for comment persistence in the notification center.
   *
   * @deprecated
   */
  shouldDeleteMessage?: boolean;
};

export interface CommentBoxStoreSlice {
  /** `true` if we're processing a publish request. */
  isBusy: boolean;

  /** `true` if our publish request failed. */
  isError: boolean;

  /** A message regarding why our publish request failed. */
  errorMsg?: string | null;

  /**
   * The result of our publish request.
   *
   * This not being null indicates that it was successful. I think.
   * TODO: Check that.
   */
  publishResult: CommentPublisherResult | null;

  /**
   * Manually requests that we focus the related editor.
   */
  isFocusRequested: boolean;

  /**
   * Should the comment editor be cleared after this result?
   */
  shouldResetEditor?: boolean;
}
